import type { FC } from 'react';

import type { GetPluginCardActionButton, PluginConfig, PluginProductCode } from './types';

export type PluginModule = {
    config: PluginConfig;
    getPluginCardActionButton?: GetPluginCardActionButton;

    /**
     * will get called on George start once if plugin is activate
     * and also after being activated first time in store
     */
    onPluginLoad?: () => void;

    /**
     * will get called once after activation in store
     */
    onPluginActivation?: () => void;

    /**
     * will get called once after deactivation in store
     */
    onPluginDeactivation?: () => void;

    /**
     * will get displayed when deactivating plugin
     */
    PluginDeactivationInfo?: FC;

    /**
     * will get displayed when deactivating plugin on signing screen
     */
    PluginDeactivationSignInfo?: FC;
};

const plugins = new Map<PluginProductCode, PluginModule>();

export function registerPluginModule(plugin: PluginModule): void {
    const id = plugin.config.productCode;
    plugins.set(id, plugin);
}

export function getPluginModule(id: PluginProductCode): PluginModule | undefined {
    return plugins.get(id);
}
